const TableSap = ({ datos }) => {
    return (
        <table className="table table-hover p-0 table-sm">
            <thead>
                <tr className="d-flex">
                    <th className="col-8">
                        <div className="font-weight-bold">
                            <div className="row">
                                <div className="col-md-3">
                                    <span className="text-default">CÓDIGO SAP</span>
                                </div>
                                <div className="col-md-9">
                                    <span className="text-default">DENOMINACIÓN</span>
                                </div>
                            </div>
                        </div>
                    </th>
                    <th className="col-4">
                        <div className="row font-weight-bold text-center">
                            <div className="col-md-2">
                                <span className="text-info">UND</span>
                            </div>
                            <div className="col-md-4">
                                <span className="text-gray">TIPO</span>
                            </div>
                            <div className="col-md-6">
                                <span className="text-teal">POS. FINANC.</span>
                            </div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                {
                    (datos.lista) &&
                    datos.lista.map((sap, index) => {
                        let numeracion = (datos.tamanioPagina * (datos.paginaActual - 1)) + index + 1
                        return (
                            <tr key={sap.codigoSap} className="d-flex ">
                                <td className="col-8">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span className="font-weight-bold">{sap.codigoSap}</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span>{sap.denominacion}</span>
                                        </div>
                                    </div>
                                </td>
                                <td className="col-4">
                                    <div className="row text-center">
                                        <div className="col-md-2">
                                            <span className="text-info">{sap.unidad}</span>
                                        </div>
                                        <div className="col-md-4">
                                            <span className="text-gray">{sap.tipo}</span>
                                        </div>
                                        <div className="col-md-6">
                                            <span className="text-teal">{sap.posicion}</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table >
    )
}
export default TableSap